<template>
   <div>

    <!-- breadcrumb area end -->
     <div class="row">
        <div class="col-lg-12">&nbsp;</div>
    </div>

     <div class="container">
        <div class="col-24"><product-details :product="product" :isAdding="true" ></product-details></div>

     </div>

      
   </div>
</template>

<script>
  import ProductDetails from '../components/products/ProductDetails'
  //import ProductCart from '../components/cart/ProductDetCart'

  export default {
    methods: {
      navigate (item) {
        console.log ("nav to :" + item);
        this.$router.push(item);
      },
      navigateBack () {
      
        this.$router.go (-1);
      }
    },
    computed: {
      product () {
        var records = this.$store.getters.allCategories;

        var id = this.$route.params['id']
        for (var i = 0; i < records.length; i++) {
            var cat = records[i];
            if (cat.Services != null)
            {
              for (var s = 0; s < cat.Services.length; s++)
              {
                 if (cat.Services[s].ArticleID == id)
                 {
                    return cat.Services[s];
                 }
              }
            }
            if (cat.SubCat != undefined)
                {
                    for (var sc = 0; sc < cat.SubCat.length; sc++) {
                        var subcat = cat.SubCat[sc].Services;
                        for (var ss = 0; ss < subcat.length; ss++)
                        {
                          if (subcat[ss].ArticleID == id)
                          {
                              return subcat[ss];
                          }
                        }
                    }
                }
        }
        return this.$store.getters.productById(this.$route.params['id'])
      }
    },
    components: {
      'product-details': ProductDetails
      //'product-cart': ProductCart
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/ServiceDetail.vue